import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { OptionsService } from '../services/options.service'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { IOptionsResponse } from '../../../common/common.types'
import { setPriorityOptions as setPriorityOptionsAction } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setPriorityOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getInsurancePriorityOptions])
    const { entity } = response
    yield put(setPriorityOptionsAction(entity))
  } catch (e) {
    yield put(throwPcrException(`setPriorityOptions() error: ${e}`))
  }
}
export function* setPriorityOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setPriorityOptions)
}
